// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__4_CUK","logo":"navbar_logo__EoF9B"};